module.exports = __webpack_public_path__ + "static/img/temp-1.221b2de6.jpg";